export default {
  us: "United States",
  fr: "Français",
  de: "Deutsch",
  es: "Español",
  tr: "Türkçe"
};
